import { render, staticRenderFns } from "./info-contacts.vue?vue&type=template&id=606080d6&scoped=true&"
import script from "./info-contacts.vue?vue&type=script&lang=js&"
export * from "./info-contacts.vue?vue&type=script&lang=js&"
import style0 from "./info-contacts.vue?vue&type=style&index=0&id=606080d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606080d6",
  null
  
)

export default component.exports